import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'mapEntry',
  standalone: true,
})
export class MapEntryPipe implements PipeTransform {
  transform<T>(map: Map<string, T>, key: string): T | undefined {
    return map.get(key);
  }
}
